<template>
    <el-dialog
        title="Update Campaign"
        :visible.sync="showForm"
        :destroy-on-close="true"
        width="85%"
        :before-close="closeDialog"
        append-to-body>
        <div v-loading="loading">
            Name:
            <input type="text" class="form-control" v-model="formData.name"></input>

            <h5 style="margin-top: 30px;">Jobs</h5>
            <campaign-job-list :employer_id="employer_id"
                               :campaign_id="campaign_id"
                               @updated="() => jobs_updated = true"
                               :campaign_options="campaign_options"></campaign-job-list>

            <template v-if="new_jobs.length">
                <h5 style="margin-top: 30px;">Add Jobs</h5>
                <jobid-job-list :employer_id="employer_id" :job_ids="new_jobs"></jobid-job-list>
            </template>

            <btn icon="fas fa-plus" :click="openAddJobsDialog">Add jobs</btn>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">Close</el-button>
            <el-button type="primary" @click="save">Save</el-button>
        </span>

        <jobs-picker
            :show="show_dialogs.add_jobs"
            :employer_id="employer_id"
            :exclude_campaign_id="campaign_id"
            @close="show_dialogs.add_jobs = false"
            v-model="new_jobs"
        ></jobs-picker>
    </el-dialog>
</template>

<script>
import CampaignJobList from "../../Job/vue/campaigns/campaign-job-list";
import JobsPicker from "../../Job/vue/campaigns/jobs-picker";
import JobidJobList from "../../Job/vue/campaigns/jobid-job-list";

export default {
    components: {JobidJobList, JobsPicker, CampaignJobList},
    props: [
        'show',
        'employer_id',
        'campaign_id',
    ],
    data() {
        return {
            show_dialogs: {
                add_jobs: false
            },
            formData: {
                name: ''
            },
            loading: true,
            new_jobs: [],
            campaign_options: [],
            jobs_updated: false,
        };
    },
    watch: {
        campaign_id() {
            this.new_jobs = [];
            this.refresh();
        }
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        refresh() {
            this.loading = true;
            axios.get(url(`admin/employer/${this.employer_id}/campaigns/dropdown`))
                 .then(response => {
                     this.campaign_options = response.data;
                     this.loading = false;
                 });

            return axios.get(url(`admin/employer/${this.employer_id}/campaigns/${this.campaign_id}/detail`))
                .then(response => {
                    this.formData.name = response.data.campaign.name;
                    this.loading = false;
                });
        },
        openAddJobsDialog() {
            this.show_dialogs.add_jobs = true;
        },
        save() {
            return axios.post(url(`admin/employer/${this.employer_id}/campaigns/${this.campaign_id}/update`), {
                name: this.formData.name,
                add_jobs: this.new_jobs
            }).then(response => {
                this.new_jobs = [];
                this.showForm = false;
                this.$emit('updated');
            })
        },
        closeDialog() {
            if (this.jobs_updated) {
                this.$emit('updated');
            }
            this.showForm = false;
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>